/* ── Packaging Popup / Drawer ── */
function openPackagingDrawerToMessage(index) {
  openPackagingDrawer(index);
  // Switch to message tab after drawer opens
  setTimeout(function() {
    var modal = document.getElementById('packaging-drawer-' + index);
    if (!modal) return;
    var msgBtn = modal.querySelectorAll('.cart-tab-btn');
    // Click the Message tab (second button)
    if (msgBtn.length > 1) {
      msgBtn[1].click();
    }
  }, 50);
}

function openPackagingDrawer(index) {
  var modal = document.getElementById('packaging-drawer-' + index);
  if (!modal) return;
  modal.style.display = 'flex';
  document.body.classList.add('disableBody');

  // Reset to packaging tab
  var pkgTab = document.getElementById('tab-packaging-' + index);
  var msgTab = document.getElementById('tab-message-' + index);
  var btns = modal.querySelectorAll('.cart-tab-btn');
  if (pkgTab) { pkgTab.classList.add('active'); }
  if (msgTab) { msgTab.classList.remove('active'); }
  if (btns.length > 1) {
    btns[0].classList.add('active');
    btns[1].classList.remove('active');
    var bg = document.getElementById('tab-bg-' + index);
    if (bg) bg.style.transform = 'translateX(0)';
  }

  // Equalize tab panel heights so Message tab matches Packaging tab
  setTimeout(function() {
    var panels = modal.querySelectorAll('.cart-tab-panel');
    var maxH = 0;
    panels.forEach(function(p) {
      p.style.minHeight = '';
      var wasHidden = !p.classList.contains('active');
      if (wasHidden) { p.style.display = 'flex'; p.style.flexDirection = 'column'; }
      maxH = Math.max(maxH, p.scrollHeight);
      if (wasHidden) { p.style.display = ''; }
    });
    panels.forEach(function(p) { p.style.minHeight = maxH + 'px'; });
  }, 10);
}

function _closePackagingModal(index) {
  var modal = document.getElementById('packaging-drawer-' + index);
  if (!modal) return;
  // Sync message toggle based on whether textarea has content
  var textarea = document.getElementById('myTextarea' + index);
  var toggle = document.getElementById('msg-toggle-' + index);
  if (toggle && textarea) {
    toggle.checked = textarea.value.trim().length > 0;
  }
  var content = modal.querySelector('.cart-packaging-modal-content');
  content.classList.add('closing');
  setTimeout(function() {
    modal.style.display = 'none';
    content.classList.remove('closing');
    document.body.classList.remove('disableBody');
  }, 250);
}

function closePackagingDrawer(event, index) {
  if (event.target.classList.contains('cart-packaging-modal')) {
    _closePackagingModal(index);
  }
}

function closePackagingDrawerX(index) {
  _closePackagingModal(index);
}

function switchPackagingTab(event, tabName, index) {
  var modal = document.getElementById('packaging-drawer-' + index);
  if (!modal) return;
  var buttons = modal.querySelectorAll('.cart-tab-btn');
  var panels = modal.querySelectorAll('.cart-tab-panel');

  buttons.forEach(function(btn) { btn.classList.remove('active'); });
  panels.forEach(function(panel) { panel.classList.remove('active'); });

  event.currentTarget.classList.add('active');
  var panel = document.getElementById('tab-' + tabName + '-' + index);
  if (panel) panel.classList.add('active');
}

function saveGiftMessage(index, variantsJson) {
  var textarea = document.getElementById('myTextarea' + index);
  if (!textarea) return;
  return new Promise(function(resolve) {
    var messageText = textarea.value;
    var hasMessage = messageText.trim().length > 0;
    UpdateMessage(messageText, variantsJson, String(index));

    var sourceRow = document.getElementById('item-' + index);
    var variantID = sourceRow ? sourceRow.getAttribute('data-variant-id') : null;
    var siblingIndexes = [String(index)];
    if (variantID) {
      document.querySelectorAll('.custom-cart-cont[data-variant-id="' + variantID + '"]').forEach(function (row) {
        var id = (row.id || '').replace('item-', '');
        if (id && siblingIndexes.indexOf(id) === -1) siblingIndexes.push(id);
      });
    }
    siblingIndexes.forEach(function (i) {
      var ta = document.getElementById('myTextarea' + i);
      if (ta && i !== String(index)) ta.value = messageText;
      var toggle = document.getElementById('msg-toggle-' + i);
      if (toggle) toggle.checked = hasMessage;
      var row = toggle ? toggle.closest('.giftmsg-row') : null;
      if (row) {
        row.classList.toggle('is-added', hasMessage);
        var addBtn = row.querySelector('.giftmsg-add');
        if (addBtn) addBtn.innerHTML = hasMessage ? '✓ Added' : '+ Add';
      }
    });
    setTimeout(resolve, 1200);
  });
}

function getUaeCurrecny() {
  const uaeCurrecny = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "AED",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: "stripIfInteger",
  });
  return uaeCurrecny;
}
function getSocialTrackingCookie() {
  try{
    const cookieName = 'social_tracking';
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName + '=') === 0) {
      return cookie.substring(cookieName.length + 1);
    }}
    return null;
  }catch(e){}
}

function getCartIdFromCookie() {
  try {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf('cart=') === 0) {
        return decodeURIComponent(cookie.substring('cart='.length));
      }
    }
    console.error('getCartIdFromCookie: cart cookie not found');
    return '';
  } catch (e) {
    console.error('getCartIdFromCookie: failed to read cart cookie', e);
    return '';
  }
}

async function handleTrackFailedAttempt(response, url, options, retries, error = null) {
  try{
    const baseStack = error ? error.stack : "No stack trace";
    const cartId = getCartIdFromCookie();
    let responseBody = "";
    try {
      if (response && typeof response.clone === "function") {
        responseBody = await response.clone().text();
      }
    } catch (e) {}
    let errorTrackingBody = {
        payload: options?.body || "No body", // Request payload, if any
        httpResCode: response?.status || "No response", // Handle undefined response
        stackTrace: `${baseStack} | cartId: ${cartId} | retryAttempt: ${retries} | responseBody: ${responseBody}`,
        url: url, // Track the URL
        action: options?.method || "GET" // Log the request method (GET, POST, etc.)
    };
    await sendTrackErrorToApi(errorTrackingBody);
  }catch(e){}
}

async function sendTrackErrorToApi(errorTrackingBody) {
  try{
  const errorTrackingApiUrl = "https://product-api.wonderdays.ae/api/incidents";
    let errorResponse = await fetch(errorTrackingApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
                },
        body: JSON.stringify(errorTrackingBody),
              });
    }catch(e){}         
}

 async function attachSocialTracking() {
  try{
  const tracking_id = getSocialTrackingCookie();
  const id= tracking_id ? tracking_id : "xxxxxx";
  const response = await fetch('/cart/update.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    attributes: { tracking_id: id }
  })
});
if (!response.ok) {
  handleTrackFailedAttempt(response, window.location.href, { tracking_id: id }, 1,{stack : response.statusText});
  }
}catch(e){}
}
////// APIs /////
function itemRequiresShippingForExpress(item) {
  if (!item) return false;
  var variantTitle = String(item.variant_title || item.variantTitle || item.variantName || "").toLowerCase();
  if (variantTitle.indexOf("e-voucher") !== -1 || variantTitle.indexOf("e voucher") !== -1) {
    return false;
  }
  if (typeof item.requires_shipping === "boolean") {
    return item.requires_shipping;
  }
  return true;
}

function resolveCartRequiresShippingForExpress(cartData) {
  if (!cartData || !cartData.items || !cartData.items.length) {
    return false;
  }
  return cartData.items.some(itemRequiresShippingForExpress);
}

async function applyCartData(cartData) {
  if (!cartData) return;
  window.CustomCartState = window.CustomCartState || {};
  window.CustomCartState.requiresShipping = resolveCartRequiresShippingForExpress(cartData);
  window.CustomCartState.totalPriceCents = parseInt(cartData.total_price, 10) || 0;
  window.CustomCartState.token = cartData.token || "";
  const tracking_uid = cartData?.attributes?.tracking_id;

  if (cartData.items.length == 0) {
    let googleContainer=document.querySelector(".google-review-container");
    let empty = document.getElementById("emptyContainerDynamic");
    let emptyCont = document.getElementById("emptyContainer");
    let cartContent = document.getElementById("CartContent");
    googleContainer.classList.add("none");
    if (cartContent) cartContent.style.display = "none";
    empty.style.display = "flex";
    if (emptyCont) emptyCont.style.display = "none";
    // localStorage.removeItem("discountCode");
    // await fetchWithRetry("/discount/CLEAR");
  } else {
    await saveDataInLocalStorage(cartData);
  }
  if (typeof window.refreshExpressCheckout === "function") {
    await window.refreshExpressCheckout(cartData);
  }
  window.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cartData } }));
  if (!tracking_uid) {
    attachSocialTracking();
  }
}

async function getCartData() {
  let res = await fetchWithRetry("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (res && res?.status == 200) {
    let cartData = await res.json();
    await applyCartData(cartData);
  }
}
///Add a new item (changing packaging)
async function addCartItem(variantID, qtn, properties) {
  let body = {
    items: [
      {
        id: variantID,
        quantity: qtn,
        properties: { ...properties },
      },
    ],
  };
  let res = await fetchWithRetry("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(body),
  });
  if (res && res?.status == 200) return res;
}

//For Message
async function updateShopifyCart(updateData) {
  const response = await fetchWithRetry("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updateData),
  });
  if (response && response?.status == 200) return response;
}


window.addEventListener("pageshow", async function () {
  document.body.classList.remove('disableBody');
   await getCartData();
  
  let checkLoader = document.querySelectorAll(".checkout-spinner");
  checkLoader.forEach((loader) => {
    loader.classList.add("none");
  });

  let checkBtn = document.querySelectorAll(".button-primary");
  checkBtn.forEach((btn) => {
    btn.disabled = false;
  });
});

async function continueShopping() {
  window.location.href = "/";
}

async function submitForm() {
  let formButton = document.getElementById("formSubmit");
  let checkLoader = document.querySelectorAll(".checkout-spinner");
  checkLoader.forEach((loader) => {
    loader.classList.remove("none");
  });
  let checkBtn = document.querySelectorAll(".button-primary");
  checkBtn.forEach((btn) => {
    btn.disabled = true;
  });
  formButton.click();
}

//////////////////  Features Functions ///////////////////////
async function UpdateMessage(text, encodedJsonVariants, index) {
  let decodedJson = decodeHTMLEntities(encodedJsonVariants);
  const variants = JSON.parse(decodedJson);
  let variantName = document.getElementById(`title-variant-${index}`).textContent;

  const item = variants.filter((i) => i.title.trim().includes(variantName.trim()))[0];
  let storedData = getDataFromLocalStorage();
  const storedItem = storedData.items.filter((i) => i.key && i.key.split(":")[0].trim() == `${item.id}`)[0];
  if (!storedItem) return;
  let __message = text;
  let newObject = {
    id: String(item.id),
    properties: {
      ...storedItem.properties,
      __message,
    },
  };
  const res = await updateShopifyCart(newObject);
  if(res && res.status==200){
    const cartData = await res.json();
    await applyCartData(cartData);
  }
}

///variant is an array if we call it from the ui, is one single value if we call it from updatePackage
async function deleteCartItemUI(index, variant, updatePackage = false) {
  const itemTrashBasket = document.querySelector(`.deleteItem-${index}`);
  const itemDeleteLoader = document.querySelector(`.delete-loader-${index}`);
  const items = document.querySelectorAll(".custom-cart-cont");
  // items.forEach((item) => {
  //   item.style.pointerEvents = "none";
  // });
  if (itemTrashBasket && updatePackage == false) {
    itemTrashBasket.classList.add("none");
    itemDeleteLoader.classList.remove("none");
  }
  let variantID;

  if (updatePackage == false) {
    let variantName = document.getElementById(`title-variant-${index}`).textContent;
    const variants = JSON.parse(variant);

    variantID = variants.filter((i) => i.title.trim() == variantName.trim())[0].id;
  } else {
    variantID = variant;
  }

  let storedData = getDataFromLocalStorage();
  const keyIndex = storedData.items.findIndex((i) => i?.key && i.key.split(":")[0] == variantID);

  const deleteObject = {
    id: String(variantID),
    quantity: 0,
  };

  const res = await updateShopifyCart(deleteObject);
  if (res && res?.status == 200) {
    if (updatePackage == false) {
      if (storedData.items[keyIndex]?.freeOffer) window.location = "/cart";
      else {
        hideCartItemsByVariant(variantID);
        const cartData = await res.clone().json();
        await applyCartData(cartData);
        itemDeleteLoader.classList.add("none");
        itemTrashBasket.classList.remove("none");
      }
    }
    items.forEach((item) => {
      item.style.pointerEvents = "auto";
    });
    return res;
  }
  else{
  if (itemTrashBasket && updatePackage == false) {
    itemTrashBasket.classList.remove("none");
    itemDeleteLoader.classList.add("none");
    jSuites.notification({
      error: 1,
      name: "Something went wrong",
      message: "Please try to delete your item again.",
    }); 
   await getCartData();
  }
  }

}

async function updateQtn(index, encodedJsonVariants, qtn) {
  let isNODiscount = document.getElementById("auto-discount")?.classList?.contains("none");
  let decodedJson = decodeHTMLEntities(encodedJsonVariants);
  const variants = JSON.parse(decodedJson);
  let variantName = document.getElementById(`title-variant-${index}`)?.textContent;

  const item = variants?.filter((i) => i?.title?.trim().includes(variantName?.trim()))[0];
  let storedData = getDataFromLocalStorage();
  const storedItem = storedData?.items?.filter((i) => i?.key && i?.key.split(":")[0].trim() == `${item?.id}`)[0];
  if(qtn){
  let newObject = {
    id: String(item.id),
    quantity: Number(qtn),
  };
  let res = await updateShopifyCart(newObject);
  if (storedItem?.freeOffer) window.location = "/cart";
  else {
    if (res && res.status == 200) {
      const cartData = await res.json();
      await applyCartData(cartData);
    }
    if (isNODiscount && !document.getElementById("auto-discount")?.classList?.contains("none")) window.location = "/cart";
    // Update packaging quantity and recalculate total
    var pkgSummaryPrice = document.getElementById('packaging-summary-price-' + index);
    if (pkgSummaryPrice) {
      pkgSummaryPrice.setAttribute('data-quantity', qtn);
      updateTotalPackagingPrice();
    }
  }
}
}

// Visual-only package selection (no save until Save button clicked)
function selectPackageOption(el, index) {
  var container = document.getElementById('packaging-' + index);
  container.querySelectorAll('.pkg-card-option').forEach(function(item) {
    item.classList.remove('selected');
  });
  el.classList.add('selected');

  // Update preview image with loading state (use gallery image from data attribute)
  var header = el.querySelector('.pkg-card-option-header');
  var gallerySrc = header ? header.getAttribute('data-gallery-img') : null;
  var preview = document.getElementById('pkg-preview-' + index);
  if (preview) {
    if (gallerySrc) {
      var alt = el.getAttribute('data-package-name') || '';
      preview.classList.add('loading');
      var newImg = new Image();
      newImg.onload = function() {
        preview.innerHTML = '';
        preview.appendChild(newImg);
        preview.classList.remove('loading');
      };
      newImg.alt = alt;
      newImg.src = gallerySrc;
    } else {
      preview.innerHTML = '';
      preview.classList.remove('loading');
    }
  }

}

// Save button in packaging drawer — saves based on active tab
async function savePackagingDrawer(index, variantsJson) {
  var btn = document.getElementById('packaging-save-btn-' + index);
  var packagingTab = document.getElementById('tab-packaging-' + index);
  var messageTab = document.getElementById('tab-message-' + index);

  var isPackagingActive = packagingTab && packagingTab.classList.contains('active');
  var isMessageActive = messageTab && messageTab.classList.contains('active');

  // Show saving state on button
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;justify-content:center;gap:8px;">Saving <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="animation:spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" stroke-width="3"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" stroke-width="3" stroke-linecap="round"/></svg></span>';
  }

  if (isPackagingActive) {
    var container = document.getElementById('packaging-' + index);
    var selected = container ? container.querySelector('.pkg-card-option.selected') : null;
    var newVariantName = selected ? selected.getAttribute('data-package-name') : null;
    if (newVariantName) {
      await changeCartItemPackage(index, newVariantName, variantsJson);
    }
  } else if (isMessageActive) {
    await saveGiftMessage(index, variantsJson);
  }

  // Show saved state then close
  if (btn) {
    btn.innerHTML = 'Saved!';
    setTimeout(function() {
      btn.disabled = false;
      btn.innerHTML = 'Save';
      _closePackagingModal(index);
    }, 1000);
  }
}

async function changeCartItemPackage(index, newVariantName, variantsJson) {
  const oldVariantName = document.getElementById(`title-variant-${index}`).textContent;
  let newVariant;
  if (oldVariantName != newVariantName) {
    const storedData = getDataFromLocalStorage();
    const variants = JSON.parse(variantsJson);
    newVariant = variants.filter((i) => i.title.toLowerCase().includes(newVariantName.toLowerCase()));

    const oldItem = variants.filter((i) => i.title.trim() == oldVariantName.trim())[0];
    const itemIndex = storedData.items.findIndex((i) => i.key && i.key.split(":")[0].trim() == `${oldItem.id}`);
    const properties = storedData.items[itemIndex]?.properties;
    const qtn = storedData.items[itemIndex]?.quantity;

    const siblingIndexes = [String(index)];
    document.querySelectorAll('.custom-cart-cont[data-variant-id="' + oldItem.id + '"]').forEach(function (row) {
      var i = (row.id || '').replace('item-', '');
      if (i && siblingIndexes.indexOf(i) === -1) siblingIndexes.push(i);
    });

    const resDelete = await deleteCartItemUI(index, oldItem.id, true);
    if(resDelete && resDelete?.status==200){
    const resAdd = await addCartItem(newVariant[0].id, qtn, properties);
    if(resAdd && resAdd?.status==200) {
      siblingIndexes.forEach(function (i) {
        changeActivePackage(i, newVariantName, newVariant[0].title);
        var row = document.getElementById('item-' + i);
        if (row) row.setAttribute('data-variant-id', newVariant[0].id);
      });
    }
    }else{
    jSuites.notification({
      error: 1,
      name: "Something went wrong",
      message: "Please try to update your package again.",
    });
    }
    await getCartData();
  }
}

// UI Updates
function applyLoaderInPackages(index, show, newVariantName) {
  let itemPackageContainer = document.getElementById(`packaging-${index}`);
  let newItemPackage = document.getElementById(`package-item-${index}-${newVariantName}`);
  let loaderItem = newItemPackage.querySelector(".circle-loader-pacakge");
  const deletedIcons = document.querySelectorAll(".custom-cart-close-icon");

  if (show) {
    itemPackageContainer.style.pointerEvents = "none";

    deletedIcons.forEach(function (element) {
      element.style.pointerEvents = "none";
    });
    if (loaderItem) {
      loaderItem.classList.remove("none");
    }
  } else {
    // itemPackageContainer.style.background = "#fff";
    itemPackageContainer.style.pointerEvents = "";
    deletedIcons.forEach(function (element) {
      element.style.pointerEvents = "";
    });
    if (loaderItem) {
      loaderItem.classList.add("none");
    }
  }
}

function changeActivePackage(index, newVariantPackage, newVariantTitle) {
  let cartItem = document.getElementById(`packaging-${index}`);
  let titleVariant = document.getElementById(`title-variant-${index}`);
  let packageItem = document.getElementById(`package-item-${index}-${newVariantPackage}`);

  let children = cartItem.children;
  for (let i = 0; i < children.length; i++) if (children[i].classList.contains("selected")) children[i].classList.remove("selected");
  packageItem.classList.add("selected");
  titleVariant.textContent = newVariantTitle;

  // Update packaging summary card variant name and price
  var summaryName = document.getElementById('packaging-summary-name-' + index);
  var summaryPrice = document.getElementById('packaging-summary-price-' + index);
  var priceEl = packageItem ? packageItem.querySelector('.pkg-card-price') : null;
  if (summaryName) {
    summaryName.childNodes[0].textContent = newVariantTitle + ' ';
  }
  if (summaryPrice && priceEl) {
    summaryPrice.textContent = '· ' + priceEl.textContent.trim();
  }

  // Update total packaging price in order summary
  updateTotalPackagingPrice();
}

function updateTotalPackagingPrice() {
  var totalDiff = 0;
  var allContainers = document.querySelectorAll('[id^="packaging-summary-price-"]');
  allContainers.forEach(function(el) {
    var text = el.textContent.replace('·', '').trim();
    if (text === 'Free') return;
    var num = parseFloat(text.replace(/[^0-9.\-]/g, ''));
    if (isNaN(num)) return;
    var qty = parseInt(el.getAttribute('data-quantity') || '1', 10);
    totalDiff += Math.round(num * 100) * qty;
  });
  var pkgEl = document.getElementById('cart__packaging');
  if (pkgEl) {
    if (totalDiff === 0) {
      pkgEl.textContent = 'Free';
    } else if (totalDiff > 0) {
      pkgEl.textContent = '+ ' + formatMoney(totalDiff);
    } else {
      pkgEl.textContent = formatMoney(totalDiff);
    }
  }
}

function formatMoney(cents) {
  var amount = cents / 100;
  if (amount === Math.floor(amount)) return 'AED ' + amount;
  return 'AED ' + amount.toFixed(2);
}

function hideCartItem(index) {
  let deletedItem = document.getElementById(`item-${index}`);
  deletedItem.style.display = "none";
}

function hideCartItemsByVariant(variantID) {
  const rows = document.querySelectorAll(`.custom-cart-cont[data-variant-id="${variantID}"]`);
  rows.forEach((row) => { row.style.display = "none"; });
}

function updatePrice(total, listPrice, packaging, numItems, couponDiscount = 0, discountCode = "", productDiscount = 0) {
  let uaeCurrecny = getUaeCurrecny();
  let totalValue = document.getElementById("cart__total");
  let totalValueMobile = document.getElementById("cart__total2"); // mobile version
  let wasTotalMobile = document.getElementById("cart__was_total_mobile");
  let subTotalValue = document.getElementById("cart__subtotal");
  let packageValue = document.getElementById("cart__packaging");
  let numberOfItems = document.getElementById("total-cart-items");
  let discountValue = document.getElementById("cart__discount");
  let discountDiv = document.getElementById("discountCode");
  let productDiscountValue = document.getElementById("cart__product_discount");
  let productDiscountDiv = document.getElementById("productDiscountRow");
  let discountField = document.getElementById("discount-code-input");
  let discountError = document.getElementById("discount-code-error");
  const extraDiscounts= ['100AED', '70AED', '50AED', '10AED'];
  
  totalValue.textContent = uaeCurrecny.format(total);
  // totalValueMobile.textContent = uaeCurrecny.format(total);
  subTotalValue.textContent = uaeCurrecny.format(listPrice);
  document.querySelectorAll('.cart-total-btn').forEach((el) => {
    el.textContent = uaeCurrecny.format(total);
  });

  if (productDiscount > 0) {
    if (productDiscountDiv) productDiscountDiv.style.display = "flex";
    if (productDiscountValue) productDiscountValue.textContent = `- ${uaeCurrecny.format(productDiscount)}`;
  } else {
    if (productDiscountDiv) productDiscountDiv.style.display = "none";
    if (productDiscountValue) productDiscountValue.textContent = `- ${uaeCurrecny.format(0)}`;
  }

  if (listPrice > total) {
    if (discountError) { discountError.innerHTML = ""; discountError.classList.remove("is-visible"); }
    if (wasTotalMobile) {
       wasTotalMobile.textContent = uaeCurrecny.format(listPrice);
       wasTotalMobile.style.display = "inline";
    }
    totalValueMobile.textContent = uaeCurrecny.format(total);
    
    if (couponDiscount > 0) {
      if (discountDiv) discountDiv.style.display = "flex";
      if (discountValue) discountValue.textContent = `- ${uaeCurrecny.format(couponDiscount)}`;
      if (discountField) discountField.value = discountCode;
      if (window.discountUI && discountCode) window.discountUI.showApplied(discountCode, couponDiscount);
    } else {
      if (discountDiv) discountDiv.style.display = "none";
      if (discountValue) discountValue.textContent = `- ${uaeCurrecny.format(0)}`;
      if (window.discountUI) window.discountUI.showInput();
    }
  } else {
    if (wasTotalMobile) wasTotalMobile.style.display = "none";
    totalValueMobile.textContent = uaeCurrecny.format(total);
    if (discountDiv) discountDiv.style.display = "none";
    if (discountValue) discountValue.textContent = `- ${uaeCurrecny.format(0)}`;
    if (window.discountUI) window.discountUI.showInput();
  }

  numberOfItems.textContent = numItems;
}
/////Utils//////
// from Meta, META30 
// UTM parameter Default (Winter20)
// srsltid = WOW31
// no UTM 1111SALE 
function getBrowserDiscountMessage(discount,discountCode) {

const discountContainer = document.getElementById("discount-msg");
  const ua = (navigator.userAgent || "").toLowerCase();

  if ((ua.indexOf("fbav") > -1 || ua.indexOf("facebook") > -1 || ua.indexOf("fban") > -1 ) && discountCode == 'meta30') {
    // Facebook in-app browser
    discountContainer?.classList?.add('discount-border-style');
    return `Facebook exclusive Code <span style='color:#d51a3c; font-weight:600;'>${discountCode.toUpperCase()}</span> applied.
           Claim your <span style='color: #d51a3c'>${discount}</span> discount before it’s gone!`;
     
  // Instagram in-app browser         
  } else if (ua.indexOf("instagram") > -1 || discountCode == 'meta30') {
    discountContainer?.classList?.add('discount-border-style');
    return `Instagram exclusive Code <span style='color:#d51a3c; font-weight:600;'>${discountCode.toUpperCase()}</span> applied.
           Claim your <span style='color: #d51a3c'>${discount}</span> discount before it’s gone!`;
  }

  if (discountCode == 'wow31' || discountCode == 'wow30') {
     discountContainer?.classList?.add('discount-border-style');
  return `Exclusive Code <span style='color:#d51a3c; font-weight:600;'>${discountCode.toUpperCase()}</span> applied.
           Claim your <span style='color: #d51a3c'>${discount}</span> discount before it’s gone!`;
  }
  
  else {
    discountContainer?.classList?.remove('discount-border-style');
    // All other browsers
    return `Congrats! Additional discount of <span style='color: #d51a3c'>${discount}</span> was applied to your basket. Offer is valid for 24 hrs.`;  }
}

// Stable per-line info keyed by variant_id, rendered by Liquid. Survives a packaging swap
// (unlike the item-salary element, whose id is keyed by SKU and goes stale on variant change).
function _pkgLineInfo(item) {
  if (!item || !window.PKG_LINE_INFO) return null;
  var id = (item.variant_id != null ? item.variant_id : item.id);
  if (id == null) return null;
  return window.PKG_LINE_INFO[id] || null;
}

function getLineItemWasPriceCents(item) {
  var info = _pkgLineInfo(item);
  if (info) return parseInt(info.was, 10) || 0;
  var el = document.getElementById(`item-salary-${item.sku}`) || document.getElementById(`item-salary-desktop-${item.sku}`);
  if (!el) return 0;
  return parseInt(el.getAttribute("data-was-price-cents"), 10) || 0;
}

// Packaging add-on (selected variant price − base/first-visible variant price).
// Subtracting it makes the line show the base price; the add-on is shown separately in the packaging summary.
function getLineItemPkgAddonCents(item) {
  var info = _pkgLineInfo(item);
  if (info) {
    var retail = parseInt(item.original_price || item.price || 0, 10) || 0;
    var addon = retail - (parseInt(info.base, 10) || retail);
    return addon > 0 ? addon : 0;
  }
  var el = document.getElementById(`item-salary-${item.sku}`) || document.getElementById(`item-salary-desktop-${item.sku}`);
  if (!el) return 0;
  return parseInt(el.getAttribute("data-pkg-addon-cents"), 10) || 0;
}

function buildLineItemPriceHtml(item, uaeCurrency) {
  if (!item) return "Free";

  var pkgAddon = getLineItemPkgAddonCents(item);
  var retailPrice = (parseInt(item.original_price || item.price || 0, 10) || 0) - pkgAddon;
  if (retailPrice < 0) retailPrice = 0;
  var finalPrice = (parseInt(item.final_price || item.discounted_price || 0, 10) || (retailPrice + pkgAddon)) - pkgAddon;
  if (finalPrice < 0) finalPrice = 0;
  var wasPrice = getLineItemWasPriceCents(item);
  var htmlParts = [];

  if (wasPrice > retailPrice) {
    htmlParts.push(`<span class='disable-old-price'>${uaeCurrency.format(wasPrice / 100)}</span>`);
  }
  if (finalPrice < retailPrice) {
    htmlParts.push(`<span class='disable-old-price'>${uaeCurrency.format(retailPrice / 100)}</span>`);
  }
  htmlParts.push(`<span class='price-current'>${uaeCurrency.format(finalPrice / 100)}</span>`);

  return htmlParts.join("");
}

function getProductDiscountTotal(cartData) {
  if (!cartData || !cartData.items) return 0;
  return cartData.items.reduce(function(total, item) {
    var wasPrice = getLineItemWasPriceCents(item);
    var pkgAddon = getLineItemPkgAddonCents(item);
    var retailPrice = (parseInt(item.original_price || item.price || 0, 10) || 0) - pkgAddon;
    if (retailPrice < 0) retailPrice = 0;
    var qty = parseInt(item.quantity || 1, 10) || 1;
    if (wasPrice > retailPrice) {
      return total + ((wasPrice - retailPrice) * qty);
    }
    return total;
  }, 0) / 100;
}

function getListPriceTotal(cartData) {
  if (!cartData || !cartData.items) return 0;
  return cartData.items.reduce(function(total, item) {
    var wasPrice = getLineItemWasPriceCents(item);
    var pkgAddon = getLineItemPkgAddonCents(item);
    var retailPrice = (parseInt(item.original_price || item.price || 0, 10) || 0) - pkgAddon;
    if (retailPrice < 0) retailPrice = 0;
    var qty = parseInt(item.quantity || 1, 10) || 1;
    var basePrice = wasPrice > retailPrice ? wasPrice : retailPrice;
    return total + (basePrice * qty);
  }, 0) / 100;
}

///LocalStorage
async function saveDataInLocalStorage(cartData) {
  let packaging = 0;
  let uaeCurrecny = getUaeCurrecny();
  let data = {
    token: "",
    price: "",
    subTotal: "",
    packaging: "",
    items: [],
    item_count: 1,
  };
  let price = cartData.total_price / 100;
  let discountCode = "";
  let buyOneGetOneDiscount = false;
  let itemDiscount = false;
  const discountField = document.getElementById("discount-field");
  const autoDiscount = document.getElementById("auto-discount");
  const discountValue = document.getElementById("discountCode");
  for (let i = 0; i < cartData.items.length; i++) {
    itemDiscount = false;
    if (
      (cartData.items[i].discounts[0] && cartData.items[i].discounts[0]?.amount == 0) ||
      cartData.items[i].discounts.findIndex((d) => d?.amount == cartData.items[i].price * cartData.items[i].quantity) > -1
    ) {
      buyOneGetOneDiscount = true;
      itemDiscount = true;
    }

    let item = {
      key: cartData.items[i].key,
      properties: {
        ...cartData.items[i].properties,
      },
      quantity: cartData.items[i].quantity,
      variantName: cartData.items[i].variant_title,
      freeOffer: itemDiscount,
      type: cartData.items[i].vendor,
    };
    data.items.push(item);
const _uaeCurrecny = getUaeCurrecny();
const discountMsg = document.getElementById("discount-msg");
if (discountMsg) {
  if (discountMsg.classList.contains('discount-placeholder')) {
    discountMsg.classList.remove('discount-placeholder');
  }
  if (cartData && cartData.total_discount > 0) {
    discountMsg.classList.remove("none");
    const calculated_amount = document.getElementById("calculated_amount");
    const discountIcon = document.getElementById("discountIcon");
    if (calculated_amount) {
      const discountCode = cartData.discount_codes.length > 0 ? cartData.discount_codes[0].code.toLowerCase() : "";
      calculated_amount.innerHTML = getBrowserDiscountMessage(_uaeCurrecny.format(cartData.total_discount / 100), discountCode);
    }
    if (discountIcon) discountIcon.innerHTML = '🔥';
  } else {
    discountMsg.classList.add("none");
  }
}

// Per-item price rendering (runs regardless of discount-msg presence)
for (let i = 0; i < cartData.items.length; i++) {
  const _it = cartData.items[i];
  const _html = buildLineItemPriceHtml(_it, _uaeCurrecny);
  const _elA = document.getElementById(`item-salary-desktop-${_it.sku}`);
  const _elB = document.getElementById(`item-salary-${_it.sku}`);
  if (_elA) _elA.innerHTML = _html;
  if (_elB) _elB.innerHTML = _html;
}

  }

  if (buyOneGetOneDiscount == true) {
    discountField.classList.add("none");
    discountValue.style.display = "flex";
    autoDiscount.classList.remove("none");
  } else {
    discountField.classList.remove("none");
    autoDiscount.classList.add("none");
  }
  data.token = cartData.token;
  data.price = price;
  data.packaging = 0; /// before: data.packaging=packaging
  data.subTotal = getListPriceTotal(cartData);
  data.item_count = cartData.item_count;
  data.productDiscount = getProductDiscountTotal(cartData);
  if (cartData.total_discount > 0) discountCode = cartData.items.filter((i) => i?.discounts && i?.discounts[0] && i?.discounts[0]?.title);
  if (discountCode.length > 0) discountCode = discountCode[0].discounts[0].title;

  let dataString = JSON.stringify(data);
  localStorage.setItem("cartObject", dataString);
  updatePrice(data.price, data.subTotal, data.packaging, data.item_count, cartData.total_discount / 100, discountCode, data.productDiscount);

}

function getDataFromLocalStorage() {
  const storedDataString = localStorage.getItem("cartObject");
  let storedData = storedDataString ? JSON.parse(storedDataString) : {};
  return storedData;
}
/// to parse variants json
function decodeHTMLEntities(text) {
  let textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  return textArea.value;
}
